import React from 'react';
import { styled } from "styled-components";
import lock from '../../assets/lock.svg';
import useUserStore from "../../data/store/useUserStore";
import { t } from 'ttag';

const Item = styled.div`
  border-radius: 66.667px;
  background: #E5DBF6;
  padding: 7.407px 22.222px;
  position: absolute;
  right: 0px;
  margin-right: 20px;
  top: 20px;
  
  color: #756393;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

const YouAreAnonymous = ({ show }) => {
  const { userId } = useUserStore();

  return (userId || show) ? (
    <Item className='anonymousBlock'>
      <img src={lock} alt={t`You’re anonymous`} />
      <span>{t`You’re anonymous`}</span>
    </Item>
  ) : null;
};

export default YouAreAnonymous;
